<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!-- Sidebar setting start -->
      <sidebar></sidebar>
      <!-- Sidebar setting end -->
      <div class="setting-info-wrp">
        <!-- Location -->
        <div class="location-box">
          <div class="row align-items-center">
            <div class="col-6">
              <h1>Assign Shifts</h1>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 p-20">
              <h2>Available Employees</h2>
              <input type="text" v-model="searchQuery" placeholder="Search employees..." class="form-control mb-3">
              <br>
              <draggable v-model="filteredAndSearchedEmployees" class="list-group" :options="{ group: 'employees' }">
                <div class="list-group-item" v-for="employee in filteredAndSearchedEmployees" :key="employee.id">
<!--                  <pre ><code>{{ employee.employeeJobType.getJobRoles  }}</code></pre>-->
                 <b> {{ employee.name }}</b>
                  <br>
                  <span class="emp-designation">
                  <span v-for="role of employee.employeeJobType" :key="role.id">
                    &nbsp;<i class="ico ico-fill-circle" v-bind:style="{color:role.get_job_roles !== null? role.get_job_roles.color: '',}"></i>
                    {{
                      role.get_job_roles !== null ? role.get_job_roles.name : ""
                    }}
                  </span>
                </span>
                </div>
              </draggable>
            </div>
            <div class="col-lg-6 p-20">
              <h2>Shifts</h2>
              <div v-for="shift in workShifts" :key="shift.id">
                <h3>{{ shift.title }} ({{ shift.start_time }} - {{ shift.end_time }}) </h3>
                <draggable v-model="shift.employees" class="list-group" :options="{ group: 'employees' }" @change="saveShifts">
                  <div class="list-group-item" v-for="employee in shift.employees" :key="employee.id">
                    {{ employee.name }}
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import sidebar from "./sidebar";
import Swal from "sweetalert2";
import draggable from 'vuedraggable';

export default {
  components: {
    sidebar,
    Swal,
    draggable
  },
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      employees: [],
      filteredEmployees: [],
      workShifts: [],
      searchQuery: ''
    }
  },
  created() {
    this.getCompanyWorkShifts();
    this.getEmployees();
  },
  computed: {
    filteredAndSearchedEmployees() {
      return this.filteredEmployees.filter(employee =>
        employee.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    getCompanyWorkShifts() {
      axios.get(this.$WorkShift, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      }).then(res => {
        if (res.data.status === 200) {
          this.workShifts = res.data.result;
          // Ensure each shift has an employees array
          this.workShifts.forEach(shift => {
            if (!shift.employees) {
              this.$set(shift, 'employees', []);
            }
          });
          this.filterEmployees();
        }
      });
    },
    getEmployees() {
      axios.get(this.$GetEmployees, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
          filter_by: "EMPLOYEE",
        }
      }).then(res => {
        if (res.data.status === 200) {
          this.employees = res.data.result;
          this.filterEmployees();
        }
      });
    },
    filterEmployees() {
      const assignedEmployeeIds = new Set();
      this.workShifts.forEach(shift => {
        shift.employees.forEach(employee => {
          assignedEmployeeIds.add(employee.id);
        });
      });
      this.filteredEmployees = this.employees.filter(employee => !assignedEmployeeIds.has(employee.id));
    },
    saveShifts() {
      axios.post(this.$SaveEmployeeShifts, {
        company_id: this.company_id,
        shifts: this.workShifts
      }, {
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status === 200) {
          // Swal.fire('Success', 'Shifts assigned successfully', 'success');
          this.filterEmployees(); // Update the available employees list
        }
      });
    }
  }
}
</script>

<style scoped>
.table tr {
  border: none !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #F7F7F7;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.list-group {
  margin-bottom: 15px;
  padding-left: 0;
  width: 100%;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: move; /* Add this to show draggable cursor */
}

.nested-list-group {
  padding-left: 20px;
}

.nested-list-group-item {
  margin-bottom: 5px;
  background-color: #f7f7f7;
}
</style>
